import { GridViewRounded } from '@mui/icons-material';
import { Tooltip } from '@mui/material';

import { ButtonIcons } from '@/components/ButtonIcons';
import { modalManagerStore } from '@/features/ModalManagerStore';

const SettingsButton = () => {
  return (
    <Tooltip title="Настройки отображения" arrow>
      <ButtonIcons onClick={() => modalManagerStore.open('settings')}>
        <GridViewRounded sx={{ width: '18px', height: '18px' }} />
      </ButtonIcons>
    </Tooltip>
  );
};

export default SettingsButton;
